import { useEffect, useState, useContext, useRef } from "react";
import { createBrowserRouter, RouterProvider, useNavigate, useParams } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../../../context.js';

import Helmet from "../../../../components/helmet.js";
import { Status, Button, Counter } from '../../../../components/component.js';

function ContactTemplateEdit() {
  const context = useContext(AppContext);

  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  useEffect(() => {
    let u = context.addSpiner();
    axios.get('/api/admin/settings').then((response) => {
      const template = response.data.contactTemplates.find(t => t.id === id);
      if (template) {
        setTitle(template.title);
        setDescription(template.description);
        setSubject(template.subject);
        setBody(template.body);
      }
      setLoading(false);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, [id]);

  function updateTemplate() {
    let u = context.addSpiner();
    axios.post('/api/admin/settings/contacts/update', {
      id,
      title,
      description,
      subject,
      body,
      files: []
    }).then((response) => {
      navigate('/settings/templates/contacts');
    }).catch((e) => {
      context.addError(e);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  if (loading) {
    return <></>;
  }

  return (
    <>
      <Helmet title="Settings | Contact Template Edit" />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-3 col-lg-6">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Patient Contact Template Update</div>
                <div className="typo-normal-175">Update the details of the patient contact template</div>
              </div>
              <div className="w-25 text-end">
                {/* <div className="item typo-normal-150 ms-2" onClick={() => navigate('/patient/create')}><FilePlus height={16} width={16} background={'none'} fill={'grey'} /> Create Patient</div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-3 col-lg-6">

            <div className="card">
              <div className="card">
                <div className="card-header sm">
                  <div className="typo-strong-200">Template Information</div>
                </div>
                <div className="card-header sm">
                  <div className="row">
                    <div className="col-xs-12 col-lg-6">
                      <div className="typo-strong-150">Title <span className="text-red">*</span></div>
                      <input type="text" placeholder="" value={title} onChange={(e) => setTitle(e.target.value)} className="input sm typo-normal-150 w-100" />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-xs-12 col-lg-8">
                      <div className="typo-strong-150">Description</div>
                      <input type="text" placeholder="" value={description} onChange={(e) => setDescription(e.target.value)} className="input sm typo-normal-150 w-100" />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-xs-12 col-lg-8">
                      <div className="typo-strong-150">Subject <span className="text-red">*</span></div>
                      <input type="text" placeholder="" value={subject} onChange={(e) => setSubject(e.target.value)} className="input sm typo-normal-150 w-100" />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-xs-12 col-lg-12">
                      <div className="typo-strong-150">Body <span className="text-red">*</span></div>
                      <textarea placeholder="Use {{patientName}} for patient name placeholder" value={body} onChange={(e) => setBody(e.target.value)} className="input sm typo-normal-150 w-100" rows="6" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-offset-3 col-lg-6 text-end">
            <Button onClick={updateTemplate} color="blue" text={"Update"} />          
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactTemplateEdit;
